import React from "react";
import { CustomLink } from "../../atoms/custom-link/customLink";

export default function CustomLinkWrapper(props) {
  const { startPos, endPos, link } = props;
  const association = (association) => {
    const key = Object.keys(association)[0];
    return association[key];
  };
  return (
    <>
      <CustomLink {...props} />
      {link.properties &&
      link.properties.connectionsProps &&
      link.properties.secondAssociation ? (
        <div
          style={{
            position: "absolute",
            left: startPos.x + 20,
            top: startPos.y + 10,
          }}
        >
          <span>{link.properties.connectionsProps.associationType}</span>
        </div>
      ) : null}
      {link.properties &&
      link.properties.connectionsProps &&
      link.properties.secondAssociation &&
      association(link.properties.secondAssociation) &&
      association(link.properties.secondAssociation).target ? (
        <div
          style={{
            position: "absolute",
            left: endPos.x + 5,
            top: endPos.y - 20,
          }}
        >
          <span>
            {
              association(link.properties.secondAssociation).target
                .associationType
            }
          </span>
        </div>
      ) : null}
    </>
  );
}
/*

 */
